export default "__VITE_ASSET__0732d9d4__"